import {
    Box,
    Dialog,
    DialogContent,
    DialogTitle,
    IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import styles from './styles.module.scss';

const YoutubeVideoDialog = ({
    open,
    onClose,
    videoId,
    title = 'Video tutorial',
}) => {
    const src = videoId
        ? `https://www.youtube.com/embed/${videoId}`
        : '';

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="md"
            fullWidth
        >
            <Box className={styles.videoDialog}>
                <DialogTitle className={styles.videoDialogTitle}>
                    {title}
                    <IconButton
                        className={styles.videoDialogCloseButton}
                        aria-label="Close video tutorial"
                        onClick={onClose}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent className={styles.videoDialogContent}>
                    <Box className={styles.videoFrame}>
                        {src ? (
                            <iframe
                                src={src}
                                title={title}
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                allowFullScreen
                            />
                        ) : null}
                    </Box>
                </DialogContent>
            </Box>
        </Dialog>
    );
};

export default YoutubeVideoDialog;
